export const GET_MENU = "GET_MENU";

export const GET_MENU_CAT = "GET_MENU_CAT";
export const GET_MENU_CAT_RECOMMENDED = "GET_MENU_CAT_RECOMMENDED";
export const GET_MENU_CAT_MOST_FAVORITE = "GET_MENU_CAT_MOST_FAVORITE";
export const GET_MENU_CAT_APPETIZER = "GET_MENU_CAT_APPETIZER";
export const GET_MENU_CAT_HOT_DISHES = "GET_MENU_CAT_HOT_DISHES";
export const GET_MENU_CAT_SEAFOOD = "GET_MENU_CAT_SEAFOOD";
export const GET_MENU_CAT_VEGETABLE = "GET_MENU_CAT_VEGETABLE";
export const GET_MENU_CAT_STAPLE = "GET_MENU_CAT_STAPLE";
export const GET_MENU_CAT_FRIED = "GET_MENU_CAT_FRIED";
export const GET_MENU_CAT_DESSERTS = "GET_MENU_CAT_DESSERTS";
export const GET_MENU_CAT_SOUP = "GET_MENU_CAT_SOUP";
export const GET_MENU_CAT_BEVERAGES = "GET_MENU_CAT_BEVERAGES";

export const GET_MENU_DETAIL = "GET_MENU_DETAIL";

export const ADD_TO_CART = "ADD_TO_CART";
export const GET_ALL_CART = "GET_ALL_CART";
export const UPDATE_CART = "UPDATE_CART";
export const DELETE_CART = "DELETE_CART";
export const UPDATE_CHECKOUT = "UPDATE_CHECKOUT";

export const GET_ORDER = "GET_ORDER";
export const CREATE_NEW_ORDER = "CREATE_NEW_ORDER";
export const POST_PAYMENT = "POST_PAYMENT";

export const GET_DISCOUNT = "GET_DISCOUNT";
export const PUT_DISCOUNT = "PUT_DISCOUNT";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const GET_DETAIL_MENU = "GET_DETAIL_MENU";
export const GET_DETAIL_USER = "GET_DETAIL_USER";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const GET_SALES_SUMMARY = "GET_SALES_SUMMARY";
export const GET_ORDER_HISTORY = "GET_ORDER_HISTORY";

export const MAKE_NEW_ORDER = "MAKE_NEW_ORDER";

export const CLEAR_CART = "CLEAR_CART";
